module.exports = __webpack_public_path__ + "static/burgers-40c2a6fbd8d7a1d559fa3e19a31869d5.jpg";